import classes from '@/components/Shares/Pagination.module.css';
import { ChunkArray } from '@/helpers/ChunkArray';
import { useLingui } from '@lingui/react';
import { Group, Pagination, SimpleGrid, Stack } from '@mantine/core';
import { useState } from 'react';
import { GameBattleCard } from '../GameTemplate/GameBattleCard';
import { gameBattles } from '../GameTemplate/data';
import { SearchFilter } from '../Search/SearchFilter';
import { sorts } from '../Search/data';
import { CardTitle } from '../Shares/CardTitle';
import { Icons } from '../Shares/Icons';
const data = ChunkArray(gameBattles, 15);
export const BattlesList: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const [activePage, setPage] = useState(1);
  const battles = data[activePage - 1].map(item => <GameBattleCard key={item.id} {...item} />);
  return <Stack>
      <Group justify="space-between">
        <CardTitle firstText="Battles" isFirstGradient colorFrom="var(--text-white)" colorTo="var(--text-white)" iconUrl="/assets/title-icons/11.png" mt={6} />
        <SearchFilter w={174} dropDownWidth={174} label={i18n._('Sort by:')} filters={sorts} breakPoint="sm">
          <Icons className="icon-pr-line-filter" fontSize={24} />
        </SearchFilter>
      </Group>

      <SimpleGrid cols={{
      base: 2,
      sm: 3,
      md: 4,
      xl: 5
    }} spacing={{
      base: 10,
      md: 20
    }}>
        {battles}
      </SimpleGrid>

      <Pagination.Root total={data.length} value={activePage} onChange={setPage} mt={20} mb={40} classNames={classes}>
        <Group gap={5} justify="center">
          <Pagination.Previous />
          <Pagination.Items />
          <Pagination.Next />
        </Group>
      </Pagination.Root>
    </Stack>;
};